/* eslint-disable camelcase */
import $ from 'jquery';
import { loadStripe } from '@stripe/stripe-js';
const stripe_publishable_key = $('body').attr('data-stripe-publishable-key');
const paymentIntentEndpoint =
  $('body').attr('data-payment-intent-endpoint') ||
  '/api/stripe/create-payment-intent';
const paymentIntentMethod =
  $('body').attr('data-payment-intent-method') || 'GET';
const thankyou_url =
  $('body').attr('data-payment-thankyou-url') ||
  'https://www.midlandsairambulance.com/donation-thank-you';
if ($('#stripe-donation-container').length && stripe_publishable_key) {
  loadStripe(stripe_publishable_key).then(stripe => {
    let client_secret = '';

    $('#donor_gift_aid').click(ev => {
      checkGiftAidFields();
    });

    function checkGiftAidFields() {
      if ($('#donor_gift_aid').is(':checked')) {
        $('.gift-aid-fields')
          .show()
          .find('input')
          .each((index, field) => {
            $(field).attr('data-parsley-excluded', null);
          });
      } else {
        $('.gift-aid-fields')
          .hide()
          .find('input')
          .each((index, field) => {
            $(field).attr('data-parsley-excluded', true);
          });
      }
      const form = $('#stripeintentform').parsley();
      if (form) {
        form.refresh();
      }
    }

    checkGiftAidFields();

    $('form[name=stripeintentform]').on('submit', ev => {
      ev.preventDefault();
      const formArray = $('form[name=stripeintentform]').serializeArray();
      const data = { giftaid: 0 };
      let amount_selection = '';
      let amount_other_value = '';
      formArray.forEach(el => {
        switch (el.name) {
          case 'donor_name':
            data.name = el.value;
            break;
          case 'donor_email':
            data.email = el.value;
            break;
          case 'donor_address1':
            data.address1 = el.value;
            break;
          case 'donor_address2':
            data.address2 = el.value;
            break;
          case 'donor_town':
            data.town = el.value;
            break;
          case 'donor_county':
            data.county = el.value;
            break;
          case 'donor_gift_aid':
            data.giftaid = el.value ? 1 : 0;
            break;
          case 'donation_amount_selection':
            amount_selection = el.value;
            break;
          case 'donation_amount_other_value':
            amount_other_value = el.value;
            break;
        }
      });

      data.amount = amount_selection;

      if (amount_selection === 'other') {
        data.amount = amount_other_value;
      }

      data.amount *= 100;
      createPaymentIntent(data);
    });

    $('[name=donation_amount_other_value]').on('focus', ev => {
      console.log(ev);
      $('[name=donation_amount_selection][value=other]').attr('checked', true);
    });

    $('[name=donation_amount_selection]').on('click', ev => {
      console.log(ev);
      $('[name=donation_amount_other_value]')
        .attr('disabled', true)
        .attr('required', null);
      if (ev.target.value === 'other') {
        $('[name=donation_amount_other_value]')
          .attr('disabled', null)
          .attr('required', true);
      }
      $('form[name=stripeintentform]')
        .parsley()
        .reset();
    });

    const $errorMsg = $('#card-error');

    const elements = stripe.elements();
    const style = {
      base: {
        backgroundColor: '#FFFFFF',
        color: '#32325d',
        fontFamily: 'Arial, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '22px',
        '::placeholder': {
          color: '#32325d',
        },
      },
      invalid: {
        fontFamily: 'Arial, sans-serif',
        color: '#fa755a',
        iconColor: '#fa755a',
      },
    };
    const card = elements.create('card', { style });

    // Stripe injects an iframe into the DOM
    card.mount('#card-element');
    card.on('change', event => {
      // Disable the Pay button if there are no card details in the Element
      $('#stripepaymentbutton').attr('disabled', event.empty);
      if (event.error) {
        showError(event.error.message);
      } else {
        $errorMsg.text('').removeClass('filled');
      }
    });

    $('#stripebackbutton').on('click', () => {
      goBack();
    });

    $('#stripepaymentform').on('submit', event => {
      event.preventDefault();
      // Complete payment when the submit button is clicked
      payWithCard(stripe, card, client_secret);
    });

    // Disable the button until we have Stripe set up on the page
    const createPaymentIntent = data => {
      $.ajax({
        url: paymentIntentEndpoint,
        method: paymentIntentMethod,
        data,
        success: data => {
          $('#stripeintentform').addClass('hidden');
          $('#stripepaymentform').removeClass('hidden');
          $('#stripepaymentbutton').attr('disabled', true);
          client_secret = data.client_secret;
        },
        error: xhr => {},
      });
    };

    // Calls stripe.confirmCardPayment
    // If the card requires authentication Stripe shows a pop-up modal to
    // prompt the user to enter authentication details without leaving your page.
    const payWithCard = (stripe, card, clientSecret) => {
      loading(true);
      $('#stripepaymentbutton').attr('disabled', true);
      stripe
        .confirmCardPayment(clientSecret, {
          payment_method: {
            card,
            /*
                        billing_details: {
                          name: 'Card holder name',
                          email: 'Cardd holder email',
                        }
                         */
          },
        })
        .then(result => {
          if (result.error) {
            // Show error to your customer
            showError(result.error.message);
          } else {
            // The payment succeeded!
            orderComplete(result.paymentIntent.id);
          }
        });
    };

    /* ------- UI helpers ------- */
    // Shows a success message when the payment is complete
    const goBack = function() {
      $('#stripepaymentbutton').attr('disabled', true);
      $('#stripepaymentform').addClass('hidden');
      $('#stripeintentform').removeClass('hidden');
    };

    /* ------- UI helpers ------- */
    // Shows a success message when the payment is complete
    const orderComplete = function(paymentIntentId) {
      loading(false);

      window.location.href = thankyou_url;
      // $('#result-message').removeClass('hidden');
      $('#stripepaymentbutton').attr('disabled', true);
      $('#stripepaymentform').addClass('hidden');
    };

    let timeOut;

    // Show the customer the error from Stripe if their card fails to charge
    const showError = errorMsgText => {
      loading(false);
      $errorMsg.text(errorMsgText).addClass('filled');
      if (timeOut) {
        clearTimeout(timeOut);
      }
      timeOut = setTimeout(() => {
        $errorMsg.text('').removeClass('filled');
      }, 4000);
    };

    // Show a spinner on payment submission
    const loading = isLoading => {
      if (isLoading) {
        // Disable the button and show a spinner
        $('#spinner').removeClass('hidden');
        $('#button-text').addClass('hidden');
      } else {
        $('#spinner').addClass('hidden');
        $('#button-text').removeClass('hidden');
      }
    };
  });
}
